angular.module('portal.countries', ['portal.i18n']);
